export function debounce<A extends unknown[]>(
  fn: (...args: A) => void,
  ms: number,
): (...args: A) => void {
  let h: number | undefined
  return (...args: A) => {
    if (h !== undefined) window.clearTimeout(h)
    h = window.setTimeout(() => fn(...args), ms)
  }
}
